'use client';
import { LaunchDarklyObservabilityBootstrap } from '@/components/launchdarkly-observability-bootstrap';
import { AUTH_TOKEN_PARAM } from '@/constants/auth';
import { createContext, ReactNode, useContext, useEffect, useState } from 'react';

type AuthContextType = {
    accessToken: string;
    clientId: string;
    clientName?: string;
};

type ProviderProps = AuthContextType & {
    children: ReactNode;
};

const AuthContext = createContext<AuthContextType>({ accessToken: '', clientId: '' });

export const useAuth = () => {
    return useContext(AuthContext);
};

const removeAuthTokenFromVisibleUrl = () => {
    const currentUrl = new URL(window.location.href);
    if (!currentUrl.searchParams.has(AUTH_TOKEN_PARAM)) {
        return;
    }

    currentUrl.searchParams.delete(AUTH_TOKEN_PARAM);
    const search = currentUrl.searchParams.toString();
    const nextUrl = `${currentUrl.pathname}${search ? `?${search}` : ''}${currentUrl.hash}`;
    window.history.replaceState(window.history.state, '', nextUrl);
};

const LaunchDarklyObservabilityGate = ({ clientId, clientName }: { clientId: string; clientName?: string }) => {
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        removeAuthTokenFromVisibleUrl();
        setIsReady(true);
    }, []);

    return isReady ? <LaunchDarklyObservabilityBootstrap clientId={clientId} clientName={clientName} /> : null;
};

export const AuthContextProvider = ({ children, ...providerValue }: ProviderProps) => {
    return (
        <AuthContext.Provider value={providerValue}>
            <LaunchDarklyObservabilityGate clientId={providerValue.clientId} clientName={providerValue.clientName} />
            {children}
        </AuthContext.Provider>
    );
};
